import {
  Injectable,
  Input,
  Output,
  OnDestroy,
  HostListener,
  AfterViewChecked,
  EventEmitter,
  OnInit,
  Component,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
  Renderer2,
  ChangeDetectorRef,
  ViewChildren,
  QueryList,
  AfterViewInit,
} from "@angular/core";

import { BfxBlotterFilterSelectorService } from "./bfx-blotter-filter-selector.service";
import { Subscription } from "rxjs";
import { BfxMultiSelectorComponent } from "../bfx-element-library/bfx-multi-selector.component";
import { DomHandler } from "@bfx/primeng/dom";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-blotter-filter-selector",
  templateUrl: "../bfx-element-library/html/bfx-multi-selector.html",
  standalone: false,
})
export class BfxBlotterFilterSelectorComponent extends BfxMultiSelectorComponent {
  constructor(
    myElement: ElementRef,
    selectorService: BfxBlotterFilterSelectorService,
    domHandler: DomHandler,
    renderer: Renderer2,
    cd: ChangeDetectorRef,
  ) {
    super(myElement, selectorService, domHandler, renderer, cd);

    this.panelStyleClass = "bfx-multi-selector-dropdown";
  }
}
